import { render } from "./legalVue.vue?vue&type=template&id=79b41c2a"
const script = {}

import "./legalVue.vue?vue&type=style&index=0&id=79b41c2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__